import * as React from 'react';
import Autosuggest from 'react-autosuggest';
import { css } from "@emotion/core";
import { StaticQuery, graphql } from 'gatsby';
import {Link} from "@fitplan/lib/components/Link";

import Icon from "@fitplan/lib/components/Icons";
import Dropdown from '../dropdown/dropdown';
import SearchIcon from '../../components/icons/SearchIcon';
import { TrainerCard, ListCard } from '../../components/trainers/TrainerCard';
import PlanCard from '../../components/planGrid/PlanCard';
import { localeTextGetter } from '../../utils/l10n';
import './grid.scss';

import SearchNotFound from '../../components/searchNotFound/searchNotFound';
import { getAthleteName } from '../../utils/helpers';

const ViewIcon = ({ active, activeComp, inactiveComp }) => {
  return (
    <div>{active ? <img src={activeComp} /> : <img src={inactiveComp} />}</div>
  );
};

const dropDownTitle = (value, base, map) => {
  if (value) {
    return map.find(option => option.value === value).name;
  }

  return base;
};

class GridRoot extends React.Component {
  constructor() {
    super();

    this.state = {
      isHovering: false,
      filterValue: undefined,
      genderValue: undefined,
      dropdownValue: undefined,
      dropdownOpen: false,
      viewType: 'grid',
      noResult: false,
      invalidSearch: false,
      searchArray: [],
      suggestions: [],
      value: '',
      key: 'server'
    };
  }

  componentDidMount() {
    this.searchPrediction();
    this.setState({key: 'client'});
  }

  searchPrediction = component => {
    if (this.props.component === 'trainers') {
      this.props.cards.edges.map(({ node }) => {
        const name = getAthleteName(node);
        const fullName = { name };
        this.setState(prevState => ({
          searchArray: [...prevState.searchArray, fullName],
        }));
      });
    }
    if (this.props.component === 'plans') {
      this.props.cards.edges.map(({ node }) => {
        const planName = { name: node.planName };
        const name = getAthleteName(node);
        const fullName = { name };
        this.setState(prevState => ({
          searchArray: [...prevState.searchArray, planName, fullName],
        }));
      });
    }
  };

  toggleHoverState = state => {
    return {
      isHovering: !state.isHovering,
    };
  };

  handleMouseHover = () => {
    this.setState(this.toggleHoverState);
  };

  onSearchAction = e => {
    const code = e.keyCode || e.which;
    if (code === 13) {
      this.executeSearchAction();
    }
  };

  executeSearchAction = () => {
    this.setState(state =>
      Object.assign(
        {},
        { filterValue: state.value },
        this.noResult(state.value) && { noResult: true }
      )
    );
  };

  onDropdownClick = e => {
    e.preventDefault();
    this.setState({ dropdownValue: e.target.value, dropdownOpen: false });
  };

  filterByGender = (gender, card) =>
    card[gender.characteristic] === gender.value;

  filterByName = (input, name) =>
    name.toLowerCase().includes(input.toLowerCase());

  filterByGoal = (input, card) => {
    if (input === 'allFitplans') {
      this.displayAll();
    }
    if (input === 'buildMuscle') {
      return card.femaleBuildAndBurn || card.maleBulkUp;
    }
    if (input === 'shredFat') {
      return card.femaleShredFat || card.maleShredFat;
    }
    return card[input];
  };

  filterPlansByGender = (gender, card) => {
    let planGender;
    if (
      card.femaleBuildAndBurn ||
      card.femaleShredFat ||
      card.femaleBootyGains ||
      card.femaleToneAndTighten
    ) {
      planGender = 'female';
    }
    if (card.maleBulkUp || card.maleShredFat || card.maleAthleticPerformance) {
      planGender = 'male';
    }
    return planGender === gender.value;
  };

  openDropdown = () => {
    this.setState({ dropdownOpen: true });
  };

  closeDropdown = () => this.setState({ dropdownOpen: false });

  toggleDropdown = () => {
    this.setState(state => ({
      dropdownOpen: !state.dropdownOpen,
    }));
  };

  handleDropdownBlur = e => {
    setTimeout(this.closeDropdown, 300);
  };

  displayAll = () =>
    this.setState({
      genderValue: undefined,
      value: '',
      filterValue: undefined,
      dropdownValue: undefined,
      noResult: false,
    });

  listDisplay = () => this.setState({ viewType: 'list' });

  gridDisplay = () => this.setState({ viewType: 'grid' });

  resetSearch = () =>
    this.setState({
      noResult: false,
      value: '',
      filterValue: undefined,
      genderValue: undefined,
      invalidSearch: false,
    });

  renderGenderButtons = () => {
    const { sanityAthletes } = this.props;
    return sanityAthletes.header.buttons.map(button => (
      <Link
        className={`grid__gender-button${
          this.state.genderValue === button ? ' selected-filter' : ''
        }`}
        key={button.name}
        onClick={() =>
          this.state.noResult
            ? this.setState({
                genderValue: button,
                noResult: false,
                value: '',
                filterValue: undefined,
              })
            : this.setState({
                genderValue: button,
              })
        }
      >
        {button.name}
      </Link>
    ));
  };

  renderAthletes = (key) => {
    const mapAthletes = athletes =>
      athletes.map(({ node }) =>
        this.state.viewType === 'grid' ? (
          <TrainerCard {...node} key={`${node.slug}-${key}`} />
        ) : (
          <ListCard {...node} key={`${node.slug}-${key}`} />
        )
      );
    const { filterValue, genderValue } = this.state;
    let athletes = this.props.cards.edges;
    if (filterValue) {
      athletes = athletes.filter(({ node }) => {
        const name = getAthleteName(node);
        return this.filterByName(filterValue, name);
      });
    }
    if (genderValue) {
      athletes = athletes.filter(({ node }) =>
        this.filterByGender(genderValue, node)
      );
    }

    if (athletes.length) {
      return mapAthletes(athletes);
    }
  };

  noResult(value) {
    let cards = this.props.cards.edges;

    const { filterValue, genderValue } = this.state;

    if (value) {
      cards = cards.filter(({ node }) => {
        // const name = getAthleteName(node);
        const name = `${getAthleteName(node)} ${node.planName}`;
        return this.filterByName(value, name);
      });
    }
    if (genderValue) {
      cards = cards.filter(({ node }) =>
        this.filterByGender(genderValue, node)
      );
    }

    return !cards.length;
  }

  renderPlans = (key) => {
    const mapPlans = plans =>
      plans.map(({ node }) => {
        if (node.planImage) {
          return <PlanCard key={`${node.slug}-${key}`} {...node} />;
        }
      });

    let plans = this.props.cards.edges;
    const { filterValue, genderValue, dropdownValue } = this.state;

    if (filterValue) {
      const planNamesResult = plans.filter(({ node }) =>
        this.filterByName(filterValue, node.planName)
      );
      const planAthleteNamesResult = plans.filter(({ node }) =>
        this.filterByName(filterValue, getAthleteName(node))
      );
      plans = [...planNamesResult, ...planAthleteNamesResult];
    }
    if (genderValue) {
      plans = plans.filter(({ node }) =>
        this.filterPlansByGender(genderValue, node)
      );
    }

    if (dropdownValue) {
      plans = plans.filter(({ node }) =>
        this.filterByGoal(dropdownValue, node)
      );
    }

    if (plans.length) {
      return mapPlans(plans);
    }
  };

  renderCards = component =>
    component === 'trainers' ? this.renderAthletes(this.state.key) : this.renderPlans(this.state.key);

  // React-autosuggest

  getSuggestions = value => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    const searchResult = this.state.searchArray.filter(
      (val, index, self) => index === self.findIndex(v => v.name === val.name)
    );

    return inputLength === 0
      ? []
      : searchResult.filter(val => val.name.toLowerCase().includes(inputValue));
  };

  getSuggestionValue = suggestion => suggestion.name;

  renderSuggestion = suggestion => <div>{suggestion.name}</div>;

  onChange = (event, { newValue }) => this.setState({ value: newValue });

  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.getSuggestions(value),
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  // above is react-autosuggestion

  render() {
    const { value, suggestions } = this.state;
    const { component, sanityAthletes, sanityPlans } = this.props;

    const assetsData = this.props.sanityAssets.homePage;
    let gridTitle;
    let allTitle;
    let placeholder;

    if (component === 'trainers') {
      const { header } = sanityAthletes;
      gridTitle = header.title;
      allTitle = header.trainers;
      placeholder = header.placeholder;
      allTitle = allTitle.split(' ');
    }
    if (component === 'plans') {
      const { filter } = sanityPlans;
      gridTitle = filter.title;
      placeholder = filter.placeholder;
      allTitle = filter.allButton;
      allTitle = allTitle.split(' ');
    }

    const inputProps = {
      placeholder,
      value,
      onChange: this.onChange,
    };

    const menu = list => {
      return (
        <div className="grid__dropdown-container">
          {list.map(option =>
            option.value === 'allFitplans' ? (
              <button
                className={`grid__dropdown-item ${
                  this.state.dropdownValue ? null : 'selected-goal'
                }`}
                value="allFitplans"
                onClick={this.displayAll}
              >
                {option.name}
              </button>
            ) : (
              <button
                value={option.value}
                onClick={this.onDropdownClick}
                className={`grid__dropdown-item ${
                  this.state.dropdownValue === option.value
                    ? 'selected-goal'
                    : null
                }`}
              >
                {option.name}
              </button>
            )
          )}
        </div>
      );
    };

    return (
      <div className="grid">
        <div className="grid__filter-container">
          <div className="grid__header">{gridTitle}</div>
          <div className="grid__filter">
            <div className="grid__gender">
              <Link
                className={`grid__gender-button${
                  !this.state.genderValue ? ' selected-filter' : ''
                }`}
                onClick={() => this.displayAll()}
              >
                <span className="grid__gender-button-mobile">
                  {allTitle[0]}
                </span>

                <span className="grid__gender-button-web">
                  &nbsp;
                  {allTitle[1]}
                </span>
              </Link>
              {this.renderGenderButtons()}
            </div>
            <div className="grid__filter-divider" />
            {component === 'plans' ? (
              <div
                className="grid__dropdown"
                onClick={this.toggleDropDown}
                onBlur={this.handleDropdownBlur}
              >
                <Dropdown
                  className="grid__dropdown-controller"
                  overlay={menu(sanityPlans.dropdown.options)}
                  trigger="click"
                >
                  <button
                    className="grid__dropdown-title"
                    onClick={this.toggleDropdown}
                  >
                    {dropDownTitle(
                      this.state.dropdownValue,
                      sanityPlans.dropdown.title,
                      sanityPlans.dropdown.options
                    )}
                    {this.state.dropdownOpen ? (
                      <Icon type="up" />
                    ) : (
                      <Icon type="down" />
                    )}
                  </button>
                </Dropdown>
              </div>
            ) : null}
            <span
              className={`grid__search ${component}-size`}
              css={css`
                display: flex;
                @media (min-width: 768px) {
                  justify-content: flex-end;
                }
              `}
            >
              {/* <input
                className="grid__search-input"
                type="text"
                placeholder={sanityAthletes.header.placeholder}
                onChange={this.handleSearch}
                value={this.state.inputValue}
                onKeyDown={this.onSearchAction}
              /> */}
              <div onKeyDown={this.onSearchAction}>
                <Autosuggest
                  suggestions={this.state.suggestions}
                  onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                  onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                  getSuggestionValue={this.getSuggestionValue}
                  renderSuggestion={this.renderSuggestion}
                  inputProps={inputProps}
                />
              </div>
              <div
                css={css`
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  border-left: none;
                  height: 45px;
                  padding: 1px 10px 1px;
                  position: absolute;
                  left: 220px;
                  @media (min-width: 350px) {
                    left: 270px;
                  }
                  @media (min-width: 600px) {
                    left: 220px;
                  }
                  @media (min-width: 768px) {
                    left: 190px;
                  }
                  @media (min-width: 900px) {
                    left: 240px;
                  }
                  @media (min-width: 1200px) {
                    left: 300px;
                  }
                `}
                onClick={this.executeSearchAction}
              >
                <SearchIcon className="grid__search-icon" />
              </div>
            </span>

            {component === 'trainers' ? (
              <div className="trainers__view">
                <p
                  css={css`
                    @media (max-width: 900px) {
                      display: none;
                    }
                  `}
                >
                  {sanityAthletes.header.view}
                </p>
                <button
                  className="trainers__view-buttons"
                  onClick={this.gridDisplay}
                >
                  <ViewIcon
                    active={this.state.viewType === 'grid'}
                    activeComp={assetsData.trainers.icons[0].image.asset.url}
                    inactiveComp={assetsData.trainers.icons[3].image.asset.url}
                  />
                </button>
                <button
                  className="trainers__view-buttons"
                  onClick={this.listDisplay}
                >
                  <ViewIcon
                    active={this.state.viewType === 'list'}
                    activeComp={assetsData.trainers.icons[4].image.asset.url}
                    inactiveComp={assetsData.trainers.icons[1].image.asset.url}
                  />
                </button>
              </div>
            ) : null}
          </div>
        </div>
        {this.state.noResult ? (
          <SearchNotFound resetSearch={this.resetSearch} />
        ) : null}
        <div className="grid__container">{this.renderCards(component)}</div>
      </div>
    );
  }
}

const Grid = props => (
  <StaticQuery
    query={graphql`
      query gridQuery {
        sanityAthletesPage {
          id
          header {
            placeholder {
              _type
              en
              es
            }
            title {
              _type
              en
              es
            }
            training {
              _type
              en
              es
            }
            view {
              _type
              en
              es
            }
            trainers {
              _type
              en
              es
            }
            buttons {
              characteristic
              name {
                _type
                en
                es
              }
              value
            }
          }
        }
        sanityAsset {
          homePage {
            trainers {
              icons {
                name
                image {
                  asset {
                    url
                  }
                }
              }
            }
          }
        }
        sanityPlansPage {
          filter {
            title {
              _type
              en
              es
            }
            allButton {
              _type
              en
              es
            }
            placeholder {
              _type
              en
              es
            }
          }
          dropdown {
            title {
              _type
              en
              es
            }
            options {
              name {
                _type
                en
                es
              }
              value
            }
          }
        }
      }
    `}
    render={data => {
      const {
        sanityAthletesPage,
        sanityAsset,
        sanityPlansPage,
      } = localeTextGetter(data);

      return (
        <GridRoot
          cards={props.cards}
          sanityAthletes={sanityAthletesPage}
          sanityAssets={sanityAsset}
          component={props.component}
          sanityPlans={sanityPlansPage}
        />
      );
    }}
  />
);

export default Grid;
